module.exports = __webpack_public_path__ + "img/254.0aa05113.gif";